module.exports = __webpack_public_path__ + "static/assets/6f48ccb80d6b5654c8365703bebdcc83.png";